import React from 'react';
import {
  RunSheet,
  Settings,
  Floorplan,
  Timeline,
  Calendar,
  EditFloorplan,
  Integrations,
  Guestbook,
  VoucherRedemptions,
} from '@eatclubapp/ec-bookings-library';
import Logout from '../components/Auth/Logout';
import NotFound from '../screens/NotFound/NotFound';
import Profile from '../components/Profile/Profile';

// Routes
// TODO conditional import of library components
const routes = [
  {
    path: ['/', '/index.html'],
    exact: true,
    pageTitle: '',
    main: () => <></>,
  },
  {
    path: '/runsheet',
    pageTitle: 'Run sheet',
    id: 'runsheet',
    exact: true,
    header: 'obee',
    main: () => <RunSheet />,
  },
  {
    path: '/floorplan',
    pageTitle: 'Floor Plan',
    id: 'floorplan',
    exact: true,
    header: 'obee',
    main: () => <Floorplan />,
  },
  {
    path: '/floorplan/edit',
    pageTitle: 'Edit Floorplan',
    id: 'editFloorplan',
    exact: true,
    header: 'custom',
    hideNavigation: true,
    forceHideNavigation: true, // No option to show on this screen
    main: () => <EditFloorplan />,
  },
  {
    path: '/timeline',
    pageTitle: 'Timeline',
    id: 'timeline',
    exact: true,
    header: 'obee',
    main: () => <Timeline />,
  },
  {
    path: '/monthly',
    pageTitle: 'Monthly',
    id: 'monthly',
    exact: true,
    header: 'obee',
    main: () => <Calendar />,
  },
  {
    path: '/guestbook',
    pageTitle: 'Guest book',
    id: 'guestbook',
    exact: true,
    header: 'obee',
    hideFilters: true,
    main: () => <Guestbook />,
  },
  {
    path: '/voucher-redemptions',
    pageTitle: 'Voucher Redemptions',
    id: 'voucherRedemptions',
    exact: true,
    header: 'obee',
    hideFilters: true,
    main: () => <VoucherRedemptions />,
  },
  {
    path: '/settings',
    pageTitle: 'Settings',
    exact: true,
    header: 'obee',
    id: 'settings',
    // header: 'custom',
    hideNavigation: true,
    forceHideNavigation: true,
    main: () => <Settings />,
  },
  {
    path: '/integrations',
    pageTitle: 'Bookings integrations',
    exact: true,
    header: 'custom',
    hideNavigation: true,
    forceHideNavigation: true,
    main: () => <Integrations />,
  },
  {
    path: '/logout',
    pageTitle: 'Logout',
    header: 'custom',
    exact: true,
    noRestaurantNeeded: true,
    main: () => <Logout />,
  },
  {
    path: '/profile',
    pageTitle: 'Profile',
    header: 'obee',
    exact: true,
    main: () => <Profile />,
  },
  {
    path: '*',
    pageTitle: 'Not Found',
    header: 'obee',
    exact: false,
    main: () => <NotFound />,
  },
];

export default routes;
